<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">
    <ol class="breadcrumb">
      <li><a href="#">{{ 'global.menu.home'|translate }}</a></li>
      <li ><a href="#" class="active" >{{'global.menu.admin.main'|translate}}</a>
      </li>
      <li><a class="active">{{'global.menu.addfund'|translate}}</a></li>
    </ol>
  </div>
  <div class="col-md-12 noBottomMargin" *ngIf="isDayDisabled">
    <div class="col-md-4 noBottomMargin">&nbsp;</div>
    <div class="col-md-4 noBottomMargin alert alert-info customMargin centertext">Please choose month first</div>
    <div class="col-md-4 noBottomMargin">&nbsp;</div>
  </div>
  <div class="col-md-12 headerDiv noBottomMargin">
    <form class="form-horizontal" [formGroup]="customFundForm" novalidate (submit)="getAllFunds(0)">
    <div class="col-md-12 noBottomMargin">
      <div class="col-md-4">
        &nbsp;
      </div>
      <div class="col-md-4">
          <input type="text" [(ngModel)]="searchString" formControlName="fundStatus" (keyup)="checkSearchString()" class="balanceSearchparamInput"
                 autofocus="off" >
          <span class="bar"></span>
          <label [ngClass]="[updateStyle ? 'customLabel' : '']">{{'fund.search' | translate}}</label>
      </div>
      <div class="col-md-4">
        &nbsp;
      </div>
    </div>
    <div class="col-md-12">
      <div class="col-md-5">
        &nbsp;
      </div>
      <div class="col-md-2">
        <dp-date-picker mode="month" class="custom_datepicker"  [(ngModel)]="period" formControlName="fundDate" [config]="datePickerConfig" ></dp-date-picker>
        <span class="loaderSpan"(click)="dateOpen()"><img class="loader" src="assets/images/ppm/calendar.png"/></span>
      </div>
      <div class="col-md-4">
        &nbsp;
      </div>
    </div>
    <div class="col-md-12">
      <div class="col-md-2 noBottomMargin">
        &nbsp;
      </div>
      <div class="col-md-3 noBottomMargin">
        <button type="button" class="btn btn-outline clearButn fundEditBtn" (click)="clearSearchData()">Clear</button>
      </div>
      <div class="col-md-2 noBottomMargin">
        &nbsp;
      </div>
      <div class="col-md-3 noBottomMargin">
        <button type="submit" class="btn btn-primary fundEditBtn" [disabled]="!customFundForm.valid">{{'document.search' | translate}}</button>
      </div>
      <div class="col-md-2 noBottomMargin">
        &nbsp;
      </div>
    </div>
     </form>
    <div class="col-md-12 headerEditDiv noBottomMargin" *ngIf="show">
      <div class="col-md-8 noBottomMargin"></div>
      <div class="col-md-4 editBtnDiv noBottomMargin">
        <button type="button" [disabled]="hideEditBtn" class="btn btn-primary fundEditBtn" data-toggle="modal" data-target="#fundModal" (click)="getForm(2, 0)">{{'fund.edit' | translate}}</button>
      </div>
    </div>
  </div>
  <div class="col-md-12 mainUserlockDiv">
    <bs-modal id="fundModal" #addfundform cssClass="addFundModal" [hidden]="hideModal" (onDismiss)="getAllFunds(0)">
      <bs-modal-header [showDismiss]="true" class="customModalHeader">
        <div class="col-md-12 noPaddingMd-12 buttnfreemargin" style="text-align: center">
          <h4 *ngIf="hide">
            <strong>ADD FUNDS</strong>
          </h4>
          <h4 *ngIf="show">
            <strong>EDIT FUNDS</strong>
          </h4>
        </div>
        <button type="button" class="close"  data-dismiss="modal" aria-hidden="true">&times;</button>
        <form class="form-horizontal" [formGroup]="customFundForm" novalidate (submit)="getForm(2,1)">
          <div class="col-md-12 noBottomMargin">
            <div class="col-md-6 alignDivRight">
              <dp-date-picker mode="month"  [(ngModel)]="period" formControlName="fundDateOnModal" [config]="datePickerConfig" ></dp-date-picker>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-primary editFormBtn" [disabled]="!customFundForm.valid">{{'document.search' | translate}}</button>
            </div>
          </div>
        </form>
      </bs-modal-header>
      <bs-modal-body>
        <div class="col-md-12 centertext" *ngIf="noformToEdit">
          <strong class="centertext">No Data Available</strong>
        </div>
        <form #passwordForm="ngForm" name="form" novalidate *ngIf="hideForms">
          <div id="fundform" *ngFor="let form of forms;let i = index;">
            <div [ngClass]="[singleFund ? 'col-md-12 fundFormRow12' : 'col-md-6 fundFormRow']">
              <h4>{{form.fundTitle}}</h4>
              <div class="login-form-group pmi_form_group">
                <input type="text"  id="fp" name="performance-{{i}}" [(ngModel)]="form.performance"
                       autocomplete="off" autofocus required >
                <span class="bar"></span>
                <label class="popupLabel">{{'fund.fundperformance' | translate}}</label>
              </div>
              <div class="login-form-group pmi_form_group">
                <input type="text"  id="employeeid" name="benchmark-{{i}}" [(ngModel)]="form.benchmark"
                       autocomplete="off" autofocus required >
                <span class="bar"></span>
                <label class="popupLabel">{{'fund.benchmark' | translate}}</label>
              </div>
              <div class="login-form-group pmi_form_group">
                <select class="fundadminSelect" name="benchmarkSource-{{i}}" [(ngModel)]="form.benchmarkSource" id="sel1" required>
                  <option *ngFor="let source of sources;let i = index;"  value="{{source.name}}" >{{source.name}}</option>
                </select>
                <span class="bar"></span>
                <label class="customSelectLabel popupLabel">{{'fund.source' | translate}}</label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-md-12">
              <div class="col-md-6 adminFundSubmit">
                <button type="button"
                        class="btn btn-default footerBtn"
                        data-dismiss="modal" >{{'fund.cancel' | translate}}</button>
              </div>
              <div class="col-md-6 adminFundSubmit">
                <button class="btn btn-primary footerBtn" (click)="addFunds(); addfundform.close()" data-dismiss="modal">{{'fund.save' | translate}}</button>
              </div>
            </div>
          </div>
        </form>
      </bs-modal-body>
    </bs-modal>
    <div class="col-md-12 noPaddingMd-12"  *ngIf="showForm">
      <div class="alert alert-success centertext" *ngIf="saveSuccess">
        <a class="close" data-dismiss="alert">×</a> {{message}}
      </div>
      <table class="table table-scrollable userTable" >
        <thead>
        <tr>
          <th colspan="3">
            {{'fund.fundtype' | translate}}
          </th>
          <th colspan="3">
            {{'fund.fundperformance' | translate}}
          </th>
          <th colspan="3">
            {{'fund.benchmark' | translate}}

          </th>
          <th colspan="6">
            {{'fund.source' | translate}}

          </th>
        </tr>
        </thead>
        <tbody *ngIf="show">
        <tr class="rowBorder" *ngFor="let fund of funds;let i = index;">
          <td colspan="3">{{fund.title}}</td>
          <td colspan="3" >{{fund.performance}}</td>
          <td colspan="3">{{fund.benchmark}}</td>
          <td colspan="6">{{fund.benchmarkSource}}</td>
        </tr>
        </tbody>
        <tbody *ngIf="hide">
        <tr class="rowBorder">
          <td class="centertext" colspan="11"><strong >No Data Available</strong></td>
          <td class="centertext" colspan="4"><button *ngIf="isAdd" type="button" class="btn btn-primary fundEditBtn" (click)="addfundform.open()">{{'fund.add' | translate}}</button></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-12 noBottommargin" *ngIf="progress">
      <img class="serviceLoader" src="assets/images/loading.gif"/>
    </div>
  </div>
</div>
